<template>
  <section id="sweetdeals"
           class="sweetdeals module">
    <div class="container">
      <h2>
        <img src="/static/images/best-of-sweetdeals_2019.png" alt="Best of SN&amp;R Sweetdeals">
      </h2>

      <div class="row">
        <div id="sweetdeals-info" class="col-sm-7">
          <p>
            Not sure who to vote for?  Discounted gift certificates for some of the best businesses in Sacramento are available at sweetdeals.
          </p>

          <div class="call-to-action-2">
            <a :href="sweetdealsUrl" target="_blank" class="gradient-1">
              Shop sweetdeals
            </a>
          </div>
        </div>

        <!-- <div class="clearfix visible-xs-block"></div> -->
      </div>

    </div>
  </section>
</template>

<script>

export default {
  data () {
    return {
      sweetdealsUrl: 'https://snrsweetdeals.newsreview.com/Offers?doResetCategory=1&category=1209'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/_site_variables.scss';
  @import '@/assets/scss/partials/_mixins.scss';

  #sweetdeals {
    background: #000 url(/static/images/SweetdealsHeader_BOS19.png) no-repeat center right;
    padding-bottom: 100px;
    padding-top: 100px;

    h2 > img {
      width: 100%;
      padding-bottom: 20px;
    }

    #sweetdeals-info {
      color: #fff;
    }

    p {
      text-shadow: 1px 1px 1px #000;
    }

    #sweetdeals-cert {
      img {
        width: 100%;
        padding-bottom: 30px;
      }
    }
  }

  .call-to-action-2 {
    padding: 50px 0;

    a {
      opacity: 1;
      border-radius: 15px;
      color: #000000;
      padding: 20px 30px;
      font-weight: 700;
      text-transform: uppercase;
      font-family: $default-font-primary;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Sweetdeals.vue